import React, { useState } from "react";

function TagStudyPopup({
  isOpen,
  onClose,
  onConfirm,
  pasteShortcut,
  selectedTag,
}) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex flex-col items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 max-w-md w-full shadow-xl">
        <div className="mb-4 text-indigo-600 dark:text-indigo-400">
          <svg
            className="w-12 h-12 mx-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
            />
          </svg>
        </div>
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2 text-center">
          New Study Session
        </h3>
        <p className="text-gray-600 dark:text-gray-300 text-center mb-6">
          You will generate a new study session to explore different areas of{" "}
          <span className="font-semibold text-gray-800 dark:text-gray-200">
            {selectedTag}
          </span>
          . The instructions will be copied to your clipboard and you will need
          to paste them into ChatGPT.
        </p>
        <div className="flex items-center justify-center gap-2 mb-2">
          <input
            type="checkbox"
            id="dontShowTagAgain"
            checked={dontShowAgain}
            onChange={(e) => {
              const newValue = e.target.checked;
              setDontShowAgain(newValue);
              if (newValue) {
                localStorage.setItem("hideTagPopup", "true");
              }
            }}
            className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
          />
          <label
            htmlFor="dontShowTagAgain"
            className="text-sm text-gray-600 dark:text-gray-400"
          >
            Don't show again
          </label>
        </div>
        {dontShowAgain ? (
          <div className="mb-6 p-3 bg-indigo-50 dark:bg-indigo-900/30 border border-indigo-200 dark:border-indigo-700 rounded-lg">
            <p className="text-sm text-indigo-800 dark:text-indigo-200">
              From now on, clicking on a tag will automatically copy the
              instructions and open ChatGPT.
            </p>
          </div>
        ) : (
          <div className="mt-7"></div>
        )}
        <div className="flex gap-3 justify-center">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(dontShowAgain)}
            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
            Copy Instructions + Open ChatGPT
          </button>
        </div>
      </div>
      <div className="-mt-4 max-w-[200px] ml-[100px] text-center">
        <svg
          className="w-6 h-6 mx-auto mt-2 text-gray-400 dark:text-gray-500 animate-bounce"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
        <div className="text-sm text-white dark:text-gray-400">
          After clicking, remember to paste ({pasteShortcut}) the instructions
          into the GPT
        </div>
      </div>
    </div>
  );
}

export default TagStudyPopup;
